export const jsonValidation = (value) => {
  if (value == null || value == undefined) {
    return "";
  }
  return value;
};
